import { mapState, mapGetters, mapMutations } from 'vuex'
import MultipleFileInput from '@/components/Ui/MultipleFileInput'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'

export default {
  name: 'TypePdf',
  components: {
    MultipleFileInput
  },
  data () {
    return {
      input: {
        title: null,
        attachments: []
      },

      // 文字数制限
      limit: {
        title: 25, // 50,
      },
    }
  },
  mounted () {
    this.init()
    this.setValidate(this.formIsValid)
  },
  computed: {
    ...mapState({
      values: state => state.noticeForm.values
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
    }),

    // placeholder
    placeholderTitle() {
      return '最大全角' + this.limit.title + '文字';
    },

    // list
    fileList () {
      let list = []
      let l = 1
      for (let i = 0; i < l; i++) {
        let n = i + 1
        list.push({
          name: 'inpImageFile' + n,
          file: this.input.attachments[i]
        })
      }
      return list
    },

    // validate
    formIsValid () {
      return Validator.validText(this.input.title) &&
        this.input.attachments.length &&
        Validator.validFile(this.input.attachments[0])
    },

    // post用にjsonbを取得
    jsonb () {
      let jsonb = {
        title: this.input.title,
      }
      if (this.input.attachments.length) {
        jsonb.attachments = this.input.attachments
      }
      return jsonb
    }
  },
  watch: {
    'input.title': function (to) {
      if (to) {
        this.input.title = Validator.charByteLimit(to, this.limit.title * 2)
      }
    },
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate(this.formIsValid)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'noticeForm/setValidate'
    }),

    init () {
      Object.keys(this.input)
        .forEach(key => {
          if (this.values.inpDeliveryContents &&
            this.values.inpDeliveryContents[key]) {
            this.input[key] = this.values.inpDeliveryContents[key]
          }
        })
    },

    // ファイル登録
    showDeleteFileButton (index) {
      if (index < this.input.attachments.length - 1) {
        return true
      } else {
        return typeof this.input.attachments[index] === 'object'
      }
    },
    changeFile ({index, file}) {
      if (this.input.attachments.length === index) {
        this.input.attachments.push(file)
      } else {
        this.$set(this.input.attachments, index, file)
      }
      // console.log('changeImageFile | input.attachments', this.input.attachments)
    },
    deleteFile ({index}) {
      this.input.attachments.splice(index, 1)
      // console.log('deleteImageFile | index : ' + index, this.input.attachments)
    },
  }
}
